import { SerializableError } from "../util/Serialization";

Error.stackTraceLimit = 100;
export class BasicError extends Error implements SerializableError {
    _className: string = "BasicError";
    _deserializeClassName: string = "BasicError";
    getIgnoreFields(): string[] {
        return [];
    }
    cause?: Error;

    constructor(name : string, message : string, cause? : Error, stack? : string){
        super(message);
        this.name = this.className + "-" + name;
        this.message = message;
        if(cause)this.cause = cause;
        if(stack) this.stack = stack;
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this);
        }
    }
    name: string;
    message: string;
    stack?: string | undefined;
    get className(){
        return this._className;
    }

}

export class UserError extends BasicError {
    _className = "UserError";
}

export class UserNotConfirmedError extends UserError {

}

export class UserNotFoundError extends BasicError {
    _className = "UserNotFoundError";

}

export class UsernameAlreadyExistsError extends UserError {

}

export class RecordNotFoundError extends BasicError {

}

export class UnavailableLockError extends BasicError {

}